import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import { Empty, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../../loading";
import CustomPagination from "../../../components/CustomWidgets/CustomPagination";
import { useTranslation } from "react-i18next";
import Vectorsorting from "../../../assets/Vectorsorting.svg";
import i18n from "../../../i18n";
import Edit from "../../../assets/Edit.svg";
import deleteicon from "../../../assets/Order/Delete.svg";
import { useSelector } from "react-redux";



const MoneyTransferTable = ({
    additionalData,
    onEdit,
    onDelete,
    pagination,
    selected
}) => {
    const { t } = useTranslation();
    const [flag, setflag] = useState(false);
    const allStores = useSelector(
        (state) => state?.storeReducer?.selectedStore?.is_select_all_store
    )

    const data = useMemo(() => additionalData || [], [additionalData]);

    // console.log("SELELELEELE",selected);


    useEffect(() => {
        if (additionalData?.length === 0 && !flag) {
            const timer = setTimeout(() => {
                setflag(true);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [additionalData, flag]);

    const columns = useMemo(
        () => [
            { Header: t("Date & Time"), accessor: "create_date" },
            {
                Header: t("From Payment Mode"),
                accessor: "from_type",
                Cell: ({ value }) => t(value) // translate value dynamically
            },
            {
                Header: t("To Payment Mode"),
                accessor: "to_type",
                Cell: ({ value }) => t(value)
            },

            {
                Header: t("Amount"),
                accessor: "amount",
                Cell: ({ row }) => `EGP ${parseFloat(row.original.amount).toFixed(2)}`,
            },

            {
                Header: t("Remarks"),
                accessor: "remarks",
                Cell: ({ row }) => {
                    const remarks = row.original.remarks || "";
                    const truncated =
                        remarks.length > 15 ? `${remarks.substring(0, 15)}...` : remarks;

                    return (
                        <Tooltip title={remarks}>
                            <span>{truncated}</span>
                        </Tooltip>
                    );
                },
            },

            // ...(allStores
            //     ? [
            //         {
            //             Header: t("Store Name"),
            //             accessor: "store_name",
            //             Cell: ({ row }) => (
            //                 <div className="text-start justify-start">
            //                     {t(row.original.store_name)}
            //                 </div>
            //             ),
            //         },
            //     ]
            //     : []),

            ...(selected === "Branch"
                ? [
                    {
                        Header: t("From Branch"),
                        accessor: "store_name",
                        Cell: ({ row }) => (
                            <div className="text-start justify-start">
                                {t(row.original.store_name)}
                            </div>
                        ),
                    },
                ]
                : []),

            ...(selected === "Branch"
                ? [
                    {
                        Header: t("To Branch"),
                        accessor: "to_store_name",
                        Cell: ({ row }) => (
                            <div className="text-start justify-start">
                                {t(row.original.to_store_name)}
                            </div>
                        ),
                    },
                ]
                : []),


            {
                Header: t("Actions"),
                accessor: "actions",
      disableSortBy: true,
                Cell: ({ row }) => (
                    <div className="flex gap-2">
                        <div className="flex justify-center">
                            <img
                                src={Edit}
                                style={{
                                    cursor: "pointer",
                                    height: "0.9rem",
                                    width: "0.9rem",
                                }}
                                alt="Edit"
                                className={`mt--2 ${i18n.language == "en" ? "mr-2" : "ml-2"}`}
                                onClick={() => onEdit(row.original)}
                            />
                        </div>
                        <img
                            className="mx-4 h-4 w-4 cursor-pointer"
                            src={deleteicon}
                            alt="deleteicon"
                            onClick={() => onDelete(row.original)}
                        />
                    </div>
                ),
            },
        ],
        [t, onEdit, onDelete]
    );


    const {
        headerGroups,
        prepareRow,
        page,
        nextPage,
        setPageSize,
        state: { pageSize },
    } = useTable(
        {
            columns,
            data: data,
            initialState: { pageSize: 10 },
        },
        useSortBy,
        usePagination,
        useRowSelect
    );

    const [pageIndex, setpageIndex] = useState(1);

    useEffect(() => {
        const pageDetails = {
            limit: pageSize,
            offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
        };

        if (pageSize) pagination(pageDetails);
    }, [pageSize, pageIndex]);

    return (
        <>
            <div
                className="container flex flex-col mx-auto mt-4"
                style={{ maxWidth: "100%" }}
            >
                {additionalData?.length == 0 && flag == false ? (
                    <div className="h-screen w-[90%] mt-2 ">
                        <ShimmerLoader />
                    </div>
                ) : (
                    <>
                        {/* Header Table (Fixed) */}
                        <div>
                            <table
                                className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                                style={{ tableLayout: "fixed" }}
                            >
                                <thead>
                                    {headerGroups.map((headerGroup, headerIndex) => {
                                        const { key: headerKey, ...headerGroupProps } =
                                            headerGroup.getHeaderGroupProps();
                                        return (
                                            <tr
                                                key={headerKey}
                                                {...headerGroupProps}
                                                className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                                            >
                                                {headerGroup.headers.map((column, colIndex) => {
                                                    const { key: columnKey, ...columnProps } =
                                                        column.getHeaderProps(
                                                            column.getSortByToggleProps()
                                                        );
                                                    return (
                                                        <th
                                                            key={columnKey}
                                                            {...columnProps}
                                                            className="py-3 whitespace-nowrap"
                                                            style={{ width: column.width }} // Set column width
                                                        >
                                                             <div className="flex flex-row items-center ms-2 text-sm leading-tight ">
                                                                                                                    {column.render("Header")}
                                                                                                                    {column.canSort && (
                                                                                                                      <span className="ms-1">
                                                                                                                        {column.isSorted ? (
                                                                                                                          column.isSortedDesc ? (
                                                                                                                            <img
                                                                                                                              src={Vectorsorting}
                                                                                                                              style={{
                                                                                                                                minHeight: 10,
                                                                                                                                minWidth: 10,
                                                                                                                              }}
                                                                                                                              alt="vector"
                                                                                                                            />
                                                                                                                          ) : (
                                                                                                                            <img
                                                                                                                              className="rotate-180"
                                                                                                                              src={Vectorsorting}
                                                                                                                              alt="vector"
                                                                                                                            />
                                                                                                                          )
                                                                                                                        ) : (
                                                                                                                          // 👇 Show a neutral icon when column is not sorted
                                                                                                                          <img
                                                                                                                            src={Vectorsorting}
                                                                                                                            alt="sortable"
                                                                                                                            style={{
                                                                                                                              minHeight: 10,
                                                                                                                              minWidth: 10,
                                                                                                                              opacity: 0.3,
                                                                                                                            }}
                                                                                                                          />
                                                                                                                        )}
                                                                                                                      </span>
                                                                                                                    )}
                                                                                                                  </div>
                                                        </th>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}
                                </thead>
                            </table>
                        </div>

                        {/* Body Table (Scrollable) */}
                        <div
                            className="scrollbar-none bg-white"
                            style={{
                                overflowY: "auto",
                                maxHeight: "450px", // Adjust height as needed
                            }}
                        >
                            <table
                                className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                                style={{ tableLayout: "fixed" }}
                            >
                                <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                                    {page.map((row) => {
                                        prepareRow(row);
                                        return (
                                            <React.Fragment key={row.id}>
                                                <tr
                                                    {...row.getRowProps()}
                                                    className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                                                //   onClick={() => openOrderList(row.original.id)}
                                                >
                                                    {row.cells.map((cell, index) => (
                                                        <td
                                                            key={index}
                                                            {...cell.getCellProps()}
                                                            className={`p-2 text-[#272728] h-1212 text-start text-sm font-normal ${index < row.cells.length - 1 ? "relative" : ""
                                                                } ${cell?.column?.Header == "Product"
                                                                    ? "cursor-pointer"
                                                                    : ""
                                                                }`}
                                                        //   style={{ width: cell.column.width }} // Match column width
                                                        >
                                                            {cell.render("Cell")}
                                                        </td>
                                                    ))}
                                                </tr>
                                            </React.Fragment>
                                        );
                                    })}
                                    {page.length === 0 && (
                                        <tr>
                                            <td colSpan={"100%"}>
                                                <Empty
                                                    className="mt-10"
                                                    description={t("No data available")}
                                                />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {/* Pagination */}
                        <div className="">
                            <CustomPagination
                                data={data?.length}
                                pageIndex={pageIndex}
                                pageCount={page?.length}
                                canPreviousPage={pageIndex != 1 ? true : false}
                                canNextPage={data?.length == pageSize ? true : false}
                                gotoPage={(page) => {
                                    nextPage(page);
                                }}
                                previousPage={() => {
                                    setpageIndex(pageIndex - 1);
                                }}
                                nextPage={() => {
                                    setpageIndex(pageIndex + 1);
                                }}
                                pageSize={pageSize}
                                setPageSize={(pageSize) => {
                                    setPageSize(pageSize);
                                }}
                            />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default MoneyTransferTable;
